import React from "react";
import PropTypes from "prop-types";
import {popupAction} from "../../actions";
import {connect} from "react-redux";

class DialogBody extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="ui-dialog-content" style={{ "overflowY": "auto" }} >
                {this.props.children}
            </div>
        );
    }
}

DialogBody.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

export default DialogBody;